import { testimonials } from "@/mocks/testimonials";
import SectionHeading from "@/components/base/SectionHeading";

export default function TestimonialSection() {
  return (
    <section className="bg-background-100 border-y border-background-200 mt-12 md:mt-16">
      <div className="max-w-portal mx-auto px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="Reader Voices"
          title="读者怎么说"
          desc="来自影视专业学生、剧组从业者与普通观众的反馈，是我们继续做幕后内容的理由。"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.id}
              className="flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <div className="flex items-center gap-1 mb-3 text-primary-600" aria-label={`评分 ${item.rating} 分`}>
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">
                {item.text}
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className={`${item.avatar} text-xl`} />
                </span>
                <span>
                  <span className="block text-sm font-bold text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500 mt-0.5">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}